import * as React from "react";

function SvgRightarrow() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12.073" height="12.073" style={{ marginTop: '-2px' }} fill='#284672 ' viewBox="0 0 15.073 15.073">
            <g id="Group_3" data-name="Group 3" transform="translate(15.073 15.073) rotate(180)">
                <path id="Icon_ionic-md-arrow-dropleft" data-name="Icon ionic-md-arrow-dropleft" d="M7.536,0,0,7.536l7.536,7.536Z" transform="translate(0 0)" fill="#284672 " />
                <path id="Icon_ionic-md-arrow-dropleft-2" data-name="Icon ionic-md-arrow-dropleft" d="M7.536,0,0,7.536l7.536,7.536Z" transform="translate(7.536 0)" fill="#284672 " />
            </g>
        </svg>
    )
}
export default SvgRightarrow;


// WEBPACK FOOTER //
// ./src/iconComponents/taskRightarrow.js